import {APIPromise} from "../services/HttpService";
import {ApiDefinition} from "./ApiDefinition";
import {InstantJobIdResponse} from "./model/instant-jobs/InstantJobIdResponse";
import {InstantJobStatusResponse} from "./model/instant-jobs/InstantJobStatusResponse";
import {InstantJobFinishDataResponse} from "./model/instant-jobs/InstantJobDataResponse";
import {InstantJobConfig} from "./model/instant-jobs/InstantJobConfig";

class InstantJobApiDefinition extends ApiDefinition {
    constructor() {
        super("/instant-jobs");
    }

    async enqueue(jobConfig: InstantJobConfig): APIPromise<InstantJobIdResponse> {
        return this.post('enqueue', jobConfig);
    }

    async getJobStatus(jobId: string): APIPromise<InstantJobStatusResponse> {
        return this.get(`${jobId}/status`);
    }

    async getJobData(jobId: string): APIPromise<InstantJobFinishDataResponse> {
        return this.get(`${jobId}/data`);
    }
}

export const InstantJobApi = new InstantJobApiDefinition();
